import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/output.css';
import './styles/forms.css';
import './styles/ui-patterns.css';
import './utils/logger'; // Initialize production logging
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
